import { CxsBasket } from '../model';

export const isSynchronized = (latestModifiedDate: string, basket?: CxsBasket): boolean => {
    const basketModifiedDate = basket?.lastModifiedDate || '';
    const outOfSync = latestModifiedDate && latestModifiedDate > basketModifiedDate;
    return !outOfSync;
};
